import useSWR from 'swr'
import logger from '@crystal-eyes/utils/logger'
import { AssessmentOption } from '@crystal-eyes/lib/assessments'

type Options = object

type State = {
  assessmentState: {
    taking: AssessmentOption
    setTaking: (newValue: AssessmentOption) => void
  }
}

let sharedTakingAssessment: AssessmentOption = 'none'
export default function useTakingAssessment({}: Options = {}): State {
  const { data: takingAssessment, mutate: setTakingAssessment } = useSWR(
    'useTakingAssessment.takingAssessment',
    () => {
      if (sharedTakingAssessment !== 'none')
        logger.info('Taking Assessment', sharedTakingAssessment)

      return sharedTakingAssessment
    },
    {
      keepPreviousData: true,
      revalidateOnFocus: false,
    },
  )

  return {
    assessmentState: {
      taking: takingAssessment || 'none',
      setTaking: (newValue: AssessmentOption) => {
        sharedTakingAssessment = newValue
        setTakingAssessment(newValue)
      },
    },
  }
}
